import React, { useCallback, useState } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Nav,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button
} from 'reactstrap';

import { TabNavigationButton } from 'components/TabNavigationButton';

const QueueMonitoring = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('is_chat');

  const toggleDropdown = () => setIsDropdownOpen((prevState) => !prevState);

  const queueTypes = {
    is_chat: 'Chat',
    is_telephony: 'Telefonia'
  };

  const handleOpenMonitoring = useCallback(
    (openInNewWindow = true) => {
      const baseUrl = window.location.origin;

      const path =
        activeTab === 'is_chat'
          ? '/monitoringChat/queues'
          : '/monitoring/queues';

      const url = `${baseUrl}${path}`;

      if (openInNewWindow) {
        window.open(
          url,
          '_blank',
          `width=${window.screen.availWidth},height=${window.screen.availHeight},resizable=yes,scrollbars=yes,status=yes`
        );
      } else {
        window.open(url, '_blank');
      }
    },
    [activeTab]
  );

  return (
    <>
      <div
        className="header pb-6 pt-5 pt-md-8 d-flex align-items-center"
        style={{
          minHeight: '100px',
          backgroundSize: 'cover',
          backgroundPosition: 'center top'
        }}
      ></div>

      <Container className="mt--6" fluid>
        <Row className="justify-content-center">
          <Col lg="8" md="10">
            <Card className="shadow border-0">
              <CardHeader className="bg-transparent pb-3">
                <h3 className="mb-0">Painel de Monitoramento</h3>
                <small className="text-muted">
                  Selecione o canal desejado e abra o painel
                </small>
              </CardHeader>

              <CardBody className="px-lg-5 py-lg-5">
                <Row className="mb-5 justify-content-center">
                  <Col md={8}>
                    <Nav justified pills className="nav-pills-circle-indicator">
                      {Object.entries(queueTypes).map(([type, label]) => (
                        <NavItem key={type}>
                          <TabNavigationButton
                            isActive={activeTab === type}
                            onClick={() => setActiveTab(type)}
                            title={label}
                            style={{ width: '100%', textAlign: 'center' }}
                          />
                        </NavItem>
                      ))}
                    </Nav>
                  </Col>
                </Row>

                <div className="text-center">
                  <h4 className="mb-4">
                    Abrir monitoramento de {queueTypes[activeTab]}
                  </h4>

                  <div className="d-flex justify-content-center">
                    <Dropdown
                      isOpen={isDropdownOpen}
                      toggle={toggleDropdown}
                      group
                    >
                      <Button
                        color="primary"
                        size="lg"
                        onClick={() => handleOpenMonitoring(true)}
                      >
                        <i className="ni ni-tv-2 mr-2" />
                        Acessar Painel
                      </Button>

                      <DropdownToggle caret split color="primary" size="lg" />

                      <DropdownMenu>
                        <DropdownItem
                          onClick={() => handleOpenMonitoring(false)}
                        >
                          <i className="ni ni-laptop mr-2" />
                          Abrir em nova guia
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>

                  <div className="mt-4 text-muted small">
                    O painel será aberto e você poderá selecionar as filas na
                    próxima tela.
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default QueueMonitoring;
